const ALLOWED_TAGS = new Set(['P', 'UL', 'OL', 'LI', 'STRONG', 'EM', 'B', 'I', 'BR', 'A', 'H3', 'H4', 'CODE', 'PRE', 'SPAN']);
const STRIP_TAGS = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'LINK', 'META']);

function isSafeHref(value) {
  if (!value) return false;
  const href = String(value).trim();
  return /^(https?:\/\/|\/|#|mailto:)/i.test(href) && !/^\s*javascript:/i.test(href);
}

/** Allow only a small HTML subset from the ticketing-AI help reply. */
export function sanitizeHelpHtml(html) {
  if (!html || typeof html !== 'string') return '';
  if (typeof DOMParser === 'undefined') return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const clean = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType !== 1) return;
      const tag = child.tagName;
      if (STRIP_TAGS.has(tag)) {
        child.remove();
        return;
      }
      if (!ALLOWED_TAGS.has(tag)) {
        const parent = child.parentNode;
        while (child.firstChild) parent.insertBefore(child.firstChild, child);
        parent.removeChild(child);
        return;
      }
      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        if (tag === 'A' && name === 'href' && isSafeHref(attr.value)) return;
        child.removeAttribute(attr.name);
      });
      if (tag === 'A') {
        const href = child.getAttribute('href') || '';
        if (href.startsWith('/') && !href.startsWith('//')) {
          child.removeAttribute('target');
          child.removeAttribute('rel');
        } else {
          child.setAttribute('target', '_blank');
          child.setAttribute('rel', 'noopener noreferrer');
        }
      }
      clean(child);
    });
  };

  clean(doc.body);
  return doc.body.innerHTML;
}
